module.exports = __webpack_public_path__ + "img/quem-somos.d673ec92.png";